import StudentReport from "@/features/report-card/components/student-report";

export default function Report() {
    return (
      <main className="min-h-screen bg-white print:bg-white">
        <StudentReport />
      </main>
    )
  }